var map = {
	"./account-center-tab.png": 1698,
	"./account-center.png": 1699,
	"./billing-tab.png": 1700,
	"./billing.png": 1701,
	"./calendar-tab.png": 1702,
	"./calendar.png": 1703,
	"./dashboard-tab.png": 1704,
	"./dashboard.png": 1705,
	"./feedback-tab.png": 1706,
	"./feedback.png": 1707,
	"./group.png": 1708,
	"./help.png": 1709,
	"./inquiry-centre.png": 1710,
	"./invoice.png": 1711,
	"./kawaconn.png": 1712,
	"./log-out-tab.png": 1713,
	"./log-out.png": 1714,
	"./mag-directory.png": 1715,
	"./my-details-tab.png": 1716,
	"./my-details.png": 1717,
	"./notification-tab.png": 1718,
	"./notification.png": 1719,
	"./powerbi.png": 1720,
	"./report-center-tab.png": 1721,
	"./report-centre.png": 1722,
	"./requestDisbursementFunding.png": 1723,
	"./revoke-tab.png": 1724,
	"./revoke.png": 1725,
	"./search-tab.png": 1726,
	"./search.png": 1727,
	"./service-center-tab.png": 1728,
	"./service-center.png": 1729,
	"./value-settings-tab.png": 1730,
	"./value-settings.png": 1731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1697;